import React, { useState } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import MasterDataApiExplorer from '../../components/MasterDataApiExplorer';
import '../PageStyles.css';
import './MasterDataPage.css';

const sampleData = [
  { code: 'US', name: 'United States' },
  { code: 'IN', name: 'India' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'MX', name: 'Mexico' },
];

const MasterDataCountries = () => {
  const [showTryApi, setShowTryApi] = useState(false);

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Countries</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {sampleData.map((row) => (
                <tr key={row.code}>
                  <td><code>{row.code}</code></td>
                  <td>{row.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <MasterDataApiExplorer slug="countries" onClose={() => setShowTryApi(false)} />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MasterDataCountries;
